function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.5 16.5h-5.4c.2 0 .4.9.4 1.4 0 .9-.4 1.8-1 2.4l-2 2c-.7.7-1.6 1-2.6 1s-1.8-.3-2.5-1l-6.1-5.8h-17L13 22.4a3.5 3.5 0 0 1-5-.1l-2-2a3 3 0 0 1-1-2.4c0-.5 0-1.3.3-1.3H1.8C.8 16.6 0 17 0 18v3.5a2 2 0 0 0 1.8 2h1.8l4.7 20a4 4 0 0 0 3.8 3h31.3a4 4 0 0 0 3.8-3l4.7-20h3.6a2 2 0 0 0 1.8-2V18a1.5 1.5 0 0 0-1.8-1.5zm-41.2 19h-3.6v-3.4h3.6v3.5-.1zm0-7h-3.6v-3.4h3.6v3.5-.1zm7.2 14h-3.6v-3.4h3.6v3.5-.1zm0-7h-3.6v-3.4h3.6v3.5-.1zm0-7h-3.6v-3.4h3.6v3.5-.1zm7.1 14h-3.5v-3.4h3.5v3.5-.1zm0-7h-3.5v-3.4h3.5v3.5-.1zm0-7h-3.5v-3.4h3.5v3.5-.1zm7.2 14h-3.6v-3.4h3.6v3.5-.1zm0-7h-3.6v-3.4h3.6v3.5-.1zm0-7h-3.6v-3.4h3.6v3.5-.1zm7.2 7h-3.6v-3.4H43v3.5-.1zm0-7h-3.6v-3.4H43v3.5-.1zM9.4 21.1c.7.7 1.8.7 2.5 0L27.7 5.4l16 15.6c.7.6 1.7.6 2.4 0l2-2a1.7 1.7 0 0 0 0-2.5L32 .5c-.7-.7-1.8-.7-2.5 0l-1.6 1.7L26 .6c-.7-.7-1.8-.7-2.5 0l-16.3 16c-.7.7-.7 1.7 0 2.4l2.2 2.1zm35.4-5c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8S43 19 43 18.1c0-1 .8-1.8 1.8-1.8v-.2zm-34 0c.9.1 1.6.9 1.6 1.8 0 1-.8 1.8-1.8 1.8S8.9 19 8.8 18c0-1 .8-1.8 1.8-1.8l.2-.2z",
  fill: "#fff"
});

var SvgIconShopping = function SvgIconShopping(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 58 47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.4,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconShopping, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_shopping.e3a36c4c.svg";
export { ForwardRef as ReactComponent };